/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */

export const meta = {
    "description": "Repman - PHP Repository Manager knowledge base."
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  meta
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Overview`}</h1>
    <p><strong parentName="p">{`Repman`}</strong>{` is a PHP repository manager. Main features:`}</p>
    <ul>
      <li parentName="ul">{`free and open source`}</li>
      <li parentName="ul">{`works as a proxy for `}<strong parentName="li">{`packagist.org`}</strong>{` (speeds up your local builds)`}</li>
      <li parentName="ul">{`hosts your private packages`}</li>
      <li parentName="ul">{`allows to create individual access tokens`}</li>
      <li parentName="ul">{`supports private package import from `}<strong parentName="li">{`GitHub`}</strong>{`, `}<strong parentName="li">{`GitLab`}</strong>{` and `}<strong parentName="li">{`Bitbucket`}</strong>{` with one click`}</li>
      <li parentName="ul">{`automatically syncs new versions thanks to webhooks`}</li>
      <li parentName="ul">{`scans your private package dependencies for known security vulnerabilities`}</li>
      <li parentName="ul">{`tracks the number of installations (ability to view statistics)`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  